/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolToolsFlatHeadIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tools-flat-head"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9 21.65Q8.45 21.65 8.06 21.26Q7.67 20.88 7.67 20.32Q7.67 19.77 8.06 19.39Q8.45 19 9 19L15 19Q15.55 19 15.94 19.39Q16.32 19.77 16.32 20.32Q16.32 20.88 15.94 21.26Q15.55 21.65 15 21.65ZM8.88 18Q8.38 18 8 17.68Q7.63 17.35 7.55 16.85L6.75 11.18Q6.7 10.9 6.72 10.65Q6.75 10.4 6.8 10.15L8.5 3.35Q8.63 2.9 8.97 2.63Q9.32 2.35 9.78 2.35L14.22 2.35Q14.68 2.35 15.03 2.63Q15.38 2.9 15.5 3.35L17.2 10.15Q17.25 10.4 17.27 10.65Q17.3 10.9 17.25 11.18L16.45 16.85Q16.38 17.35 16 17.68Q15.63 18 15.13 18ZM9.72 9.35L14.28 9.35L13.2 5L10.8 5Z" fill={color} />
    </svg>
  );
}
